import { Icon } from "../base/Icon";
import { DropdownField, Text, View } from "../base";

type ProviderConfig = {
  value: string;
  label: React.ReactNode;
  helpText?: string;
};

const PROVIDER_TYPES: ProviderConfig[] = [
  {
    value: "telnyx",
    label: (
      <View className="flex items-center gap-2">
        <Icon
          name="telnyx"
          size={16}
          className="text-gray-700 dark:text-gray-300"
        />
        <Text className="text-gray-700 dark:text-gray-300">Telnyx</Text>
      </View>
    ),
    helpText: "An API Key can be created in the Telnyx dashboard under the API Keys section from the user menu.",
  },
  {
    value: "twilio",
    label: (
      <View className="flex items-center gap-2">
        <Icon
          name="twilio"
          size={16}
          className="text-gray-700 dark:text-gray-300"
        />
        <Text className="text-gray-700 dark:text-gray-300">Twilio</Text>
      </View>
    ),
    helpText:
      'It is recommended to create a new subaccount. Use the Account SID for this subaccount and create a "Restricted API Key" with the permissions you need.',
  },
  {
    value: "infobip",
    label: (
      <View className="flex items-center gap-2">
        <Icon
          name="infobip"
          size={16}
          className="text-gray-700 dark:text-gray-300"
        />
        <Text className="text-gray-700 dark:text-gray-300">Infobip</Text>
      </View>
    ),
    helpText:
      "Provide the API Key from your Infobip account, the base URL (e.g. https://xxxxx.api.infobip.com), and the Media Stream Config ID for audio streaming.",
  },
  {
    value: "voicerun-sbc",
    label: (
      <View className="flex items-center gap-2">
        <Icon
          name="voicerun-sbc"
          size={16}
          className="text-gray-700 dark:text-gray-300"
        />
        <Text className="text-gray-700 dark:text-gray-300">VoiceRun SBC</Text>
      </View>
    ),
    helpText: "Provide the SBC base URL and dashboard credentials, along with the Twilio account and SIP trunk name used for inbound call routing.",
  },
];

type TelephonyProviderDropdownProps = {
  value?: string;
  onChange: (value: string) => void;
  label?: string;
  placeholder?: string;
  readOnly?: boolean;
  className?: string;
  showHelpText?: boolean;
  isAdmin?: boolean;
};

export const TelephonyProviderDropdown = ({
  value,
  onChange,
  label = "Provider",
  placeholder = "Select a provider",
  readOnly = false,
  className,
  showHelpText = false,
  isAdmin = false,
}: TelephonyProviderDropdownProps) => {
  const availableProviders = isAdmin ? PROVIDER_TYPES : PROVIDER_TYPES.filter((p) => p.value !== "voicerun-sbc");
  const selectedProvider = availableProviders.find((p) => p.value === value);

  return (
    <View className={className}>
      <DropdownField
        name="providerType"
        label={label}
        options={availableProviders}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
      />

      {showHelpText && selectedProvider?.helpText && (
        <Text
          variant="muted"
          className="text-sm mt-2"
        >
          {selectedProvider.helpText}
        </Text>
      )}
    </View>
  );
};
